let resumeData = {
    "imagebaseurl":"",
    "name": "Adam Finch",
    "role": "",
    "linkedinId":"atyreefinch",
    "skypeid": "atyreefinch",
    "roleDescription": "dad, developer, creative producer, writer, animator",
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/atyreefinch/",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"https://github.com/polezo",
          "className":"fa fa-github"
        },
        {
          "name":"skype",
          "url":"https://twitter.com/atyreefinch",
          "className":"fa fa-twitter"
        }
      ],
    "aboutme":"Over the past 8 years I have specialized in creative development, content marketing, web and video production for mission driven clients like AARP and the CDC. My experience includes a proven track record of developing new campaigns, websites, videos and interactive experiences, a history of testing and refining content and campaigns to ensure they deliver industry leading results, and an MBA with a specialization in digital media management.",
    "address":"Washington DC",
    "website":"https://atfmakes.com",
    "education":[
      {
        "UniversityName":"Flatiron School",
        "specialization":"Software Engineering",
        "MonthOfPassing":"January",
        "YearOfPassing":"2020",
        "Achievements":"Full Stack Web Development, Ruby on Rails and JavaScript Program"
      },
      {
        "UniversityName":"St. Edwards University",
        "specialization":"Masters of Business Administration",
        "MonthOfPassing":"May",
        "YearOfPassing":"2012",
        "Achievements":"MBA with a Specialization in Digital Media Management"
      },
      {
        "UniversityName":"Trinity University",
        "specialization":"Bachelor of Arts",
        "MonthOfPassing":"May",
        "YearOfPassing":"2006",
        "Achievements":"English Major, Political Science Minor"
      }
    ],
    "work":[
      {
        "CompanyName":"AARP",
        "specialization":"Web Producer",
        "MonthOfLeaving":"October 2015",
        "YearOfLeaving":"- October 2019",
        "Achievements":["Planned and implemented platform and content strategies for Staying Sharp, AARP’s brain health platform"," Responsible for SEO and SEM as well as building new content in the CMS", "Collaborated with research group to A/B test new features and optimize the user experience","Worked with high-visibility content partners and vendors to write and produce videos and other content which both support public health and deliver key organizational conversions"]
      },
      {
        "CompanyName":"Westat",
        "specialization":"Digital and Social Media Specialist",
        "MonthOfLeaving":"Feb 2013",
        "YearOfLeaving":"- October 2015",
        "Achievements":["Planned and executed digital communication strategies for high profile public health initiatives on behalf of the CDC and National Institutes of Health","Generated over 200 million earned and paid impressions to promote flu vaccination initiatives, producing an extremely cost effective campaign effort for CDC","Analyzed and evaluated digital campaign results that helped optimize campaigns and provide industry leading results for clients"]
      },
      {
        "CompanyName":"bandLENS",
        "specialization":"Producer",
        "MonthOfLeaving":"Mar 2011",
        "YearOfLeaving":"- May 2015",
        "Achievements":["Produced commercials, music videos communication strategies, promotional material and original content","Designed and animated motion graphic content that integrated with clients’ branding opportunities","Coordinated with clients to generate RFPs and corresponding bids for video production requests"]
      }
    ],
    "skillsDescription":"I've worn quite a few hats in my career",
    "skills":[
      {
        "skillname":"HTML5",
        "skilldisplay":"HTML5",
        "id":0
      },
      {
        "skillname":"Reactjs",
        "skilldisplay":"Reactjs",
        "id":1
      },
      {
        "skillname":"Unity",
        "skilldisplay":"Unity",
        "id":2
      },
      {
        "skillname":"CSharp",
        "skilldisplay":"C#",
        "id":3
      },
    ],
    "skills2":[
      {
        "skillname":"Csuite",
        "skilldisplay":"Adobe Creative Suite",
        "id":4
      },
      {
        "skillname":"Seoan",
        "skilldisplay":"Content Marketing",
        "id":5
      },
      {
        "skillname":"Production",
        "skilldisplay":"Creative Production",
        "id":6
      },
      {
        "skillname":"HatWearing",
        "skilldisplay":"Hat Wearing",
        "id":7
      },
    ],
    "skills3":[
      {
        "skillname":"Bbq",
        "skilldisplay":"BARBECUING",
        "id":8
      },
      {
        "skillname":"Kidsbook",
        "skilldisplay":"CHILDREN'S BOOK VOICES",
        "id":9
      },
      {
        "skillname":"Golf",
        "skilldisplay":"GOLF",
        "id":10
      },
      {
        "skillname":"Trombone",
        "skilldisplay":"Trombone",
        "id":11
      },
      
    ],
    "skills4":[
      {
        "skillname":"RoR",
        "skilldisplay":"Ruby on Rails",
        "id":12
      },
      {
        "skillname":"git",
        "skilldisplay":"git",
        "id":13
      },
      {
        "skillname":"ProjectManagement",
        "skilldisplay":"Project Management",
        "id":14
      },
      {
        "skillname":"smashbros",
        "skilldisplay":"Super Smash Bros",
        "id":15
      },
    ],
    "portfolio":[
      {
        "name":"ReactToWork",
        "description":"A Job Board for React Engineers, Built with React",
        "imgurl":"https://atfmakes.com/img/ReactToWorkSplash2.jpg"
      },
      {
        "name":"LetterLagoon",
        "description":"A Spelling and Phonics iOS App Built with React Native",  
        "imgurl":"https://atfmakes.com/img/LetterLagoonSplash.jpg"
      },
      {
        "name":"BrewQueue",
        "description":"IMDB for Breweries, Built with Ruby on Rails",  
        "imgurl":"https://atfmakes.com/img/BrewQueueSplash.jpg"
      },
      {
        "name":"NumberCommander",
        "description":"A Math Game for Elementary Age Kids, Built with ThreeJS",
        "imgurl":"https://atfmakes.com/img/NumberCommanderSplash2.jpg"
      },
      {
        "name":"MemoryPalace AR",
        "description":"An Augmented Reality Memory Game Prototype for AARP, Built in Unity",
        "imgurl":"https://atfmakes.com/img/MemoryPalaceSplash2.jpg"
      },
      {
        "name":"MetaverseOnDemand",
        "description":"An AR Search Engine for Google Poly Models, Built with A-Frame and AR.js",  
        "imgurl":"https://atfmakes.com/img/MetaVerseARSplash2.jpg"
      },
      {
        "name":"Martin Yan Recipe Videos",
        "description":"Brain Friendly Recipe Videos for Staying Sharp",
        "imgurl":"https://atfmakes.com/img/MartinYanSplash.jpg"
      },
      {
        "name":"JetShare Explainer",
        "description":"An Animated Explainer for JetShare",
        "imgurl":"https://atfmakes.com/img/JetShareSplash.jpg"
      },
      {
        "name":"Blue Demon Mask",
        "description":"An Instagram AR Effect, Built with Spark AR and Javascript",
        "imgurl":"https://atfmakes.com/img/FlameDemonSplash.jpg"
      },
      {
        "name":"Bolt Pattern Pro",
        "description":"A Commercial for the Bolt Patter Pro",
        "imgurl":"https://atfmakes.com/img/BoltPatternSplash.jpg"
      },
      {
        "name":"CDC Motion Infographics",
        "description":"An Award Winning Series of GIFs for the CDC",
        "imgurl":"https://atfmakes.com/img/CDC-NIVWSplash.gif"
      },
      {
        "name":"Words Before Rumble",
        "description":"Kinetic Typography of one of Mohammed Ali's Best Speeches",
        "imgurl":"https://atfmakes.com/img/AliSplash.jpg"
      },
      
    ],
    "testimonials":[
      {
        "description":"This is a sample testimonial",
        "name":"Some technical guy"
      },
      {
        "description":"This is a sample testimonial",
        "name":"Some technical guy"
      }
    ]
  }
  
  export default resumeData